import axios from "axios";
const BASE_URL = process.env.VUE_APP_API_URL;
import { Message, MessageBox } from "element-ui";
let msgBool = true; //解决一个页面弹框多次的问题
import NO_MSG_ERROR_CODE from "./code.js";
// import  router from "@/router";
import setting from "./config";
import { blob2Json } from "./help";

const http = axios.create({
  baseURL: BASE_URL,
  timeout: setting.timeout, // 请求超时时间
});

// 添加request拦截器
http.interceptors.request.use(
  (config) => {
    // console.log(config);
    const language = config.data?.language || "zh_CN";
    config.headers = {
      ...config.headers,
      appId: setting.appId,
      language,
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// 添加response拦截器
http.interceptors.response.use(
  async (response) => {
    if (Object.prototype.toString.call(response.data).slice(8, -1) === "Blob") {
      if (response.data.type === "application/json") {
        response.data = await blob2Json(response.data);
      } else {
        return Promise.resolve(response);
      }
    }

    // 接口状态码为0，一切正常
    if (response.data.code === 0) {
      return Promise.resolve(response.data.data);
    } else {
      // 状态码不为0
      if (
        !NO_MSG_ERROR_CODE.includes(response.data.code) &&
        !response.config.noMsgFlag
      ) {
        Message.error(response.data.msg);
      }
      // 如果用户过期，则弹出过期提示并且跳转登录页面
      if (+response.data.code === 14005) {
        if (msgBool) {
          msgBool = false;
          MessageBox.alert(response.data.msg, "提示", {
            confirmButtonText: "确定",
            callback: () => {
              msgBool = true;
              // todo: 主应用中如何保存用户信息并进行跳转
              // router.replace({
              //   name: "Login",
              //   query: { redirect: router.currentRoute.fullPath }, //登录后再跳回此页面时要做的配置
              // });
            },
          });
        }
      }
      return Promise.reject(response.data);
    }
  },
  (error) => {
    console.log(error);
    if (error.response) {
      switch (error.response.status) {
        case 401:
          console.log(401);
          break;
        case 403:
          console.log(403);
          break;
        case 404:
          console.log(404);
          break;
        case 500:
          console.log(500);
          break;
      }
    }
    Message.error("请求失败!");
    return Promise.reject(error);
  }
);

export default http;
